export var DataCatalogPolicyResourceType;
(function (DataCatalogPolicyResourceType) {
    DataCatalogPolicyResourceType["DATA_CATALOG_POLICY_RESOURCE_TYPE_CATALOG"] = "CATALOG";
    DataCatalogPolicyResourceType["DATA_CATALOG_POLICY_RESOURCE_TYPE_NAMESPACE"] = "NAMESPACE";
    DataCatalogPolicyResourceType["DATA_CATALOG_POLICY_RESOURCE_TYPE_DATASET"] = "DATASET";
})(DataCatalogPolicyResourceType || (DataCatalogPolicyResourceType = {}));
